import type { RouteRecordRaw } from 'vue-router';

export const INVENTORY_MONTH_ROUTER: RouteRecordRaw[] = [
  {
    path: '/inventory/month',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/inventory/month/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/inventory/month/views/List.vue'),
        name: 'Month List',
        meta: {
          title: '월재고마감조회',
        },
      },
    ],
  },
];
